import InvoiceIcon from "@assets/images/invoices.svg";
import ShippingIcon from "@assets/images/shipping-icon.svg";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup
} from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { ShippingTypeEnum } from "@saleor/createOrder/components/CollectionForm/CustomerData/Shipping";
import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl/lib";

import {
  ModalShippingProps,
  useStyles
} from "../CollectionForm/CustomerData/ModalShipping/ModalShipping";

interface ProductModalShippingProps extends ModalShippingProps {
  mainTitle: string;
  subTitle?: string;
}

const ModalShipping: React.FC<ProductModalShippingProps> = props => {
  const {
    visible,
    onClose,
    type,
    address,
    handleApplyShipping,
    initialValue,
    mainTitle,
    subTitle
  } = props;
  const classes = useStyles({});
  const [shipping, setShipping] = useState<string>("");

  useEffect(() => {
    if (visible) {
      const getValue =
        initialValue ||
        `${address?.[0]?.streetAddress1} ${address?.[0]?.streetAddress2}`;
      setShipping(getValue);
    }
  }, [visible]);

  const dataRenderModal = {
    iconHead:
      type === ShippingTypeEnum.TaxInvoices ? InvoiceIcon : ShippingIcon,
    titleHead:
      type === ShippingTypeEnum.TaxInvoices
        ? "เลือกที่อยู่สำหรับออกใบกำกับภาษี"
        : "เลือกสถานที่จัดส่งสินค้า",
    shippingAddres: address,
    label:
      type === ShippingTypeEnum.TaxInvoices
        ? "ข้อมูลที่อยู่สำหรับออกใบกำกับภาษี"
        : "ข้อมูลสถานที่จัดส่ง"
  };

  const clearSelectVariant = () => {
    onClose();
    setShipping("");
  };

  const handleSubmit = () => {
    handleApplyShipping(shipping);
    clearSelectVariant();
  };

  return (
    <Dialog open={visible} onClose={onClose} className={classes.root}>
      <DialogTitle className={classes.dialogTitle}>
        <img src={dataRenderModal?.iconHead} alt={type.toString()} />
        <MyTypography variant="h6" className={classes.mainTitle}>
          {mainTitle}{" "}
          {subTitle ? <span className={classes.subTitle}>{subTitle}</span> : ""}
        </MyTypography>
      </DialogTitle>
      <DialogContent dividers={false} className={classes.dialogContent}>
        <Grid container>
          <Grid item xs={12} md={12}>
            <FormControl>
              <FormLabel id="demo-controlled-radio-buttons-group">
                <MyTypography variant="subtitle3">
                  {dataRenderModal?.label}
                </MyTypography>
              </FormLabel>
              <RadioGroup
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
                value={shipping}
                onChange={e => setShipping(e?.target?.value)}
              >
                {dataRenderModal?.shippingAddres?.map(
                  (shippingAddress, index) => (
                    <FormControlLabel
                      key={index}
                      value={`${shippingAddress?.streetAddress1} ${shippingAddress?.streetAddress2}`}
                      control={<Radio />}
                      label={`${shippingAddress?.streetAddress1} ${shippingAddress?.streetAddress2}`}
                    />
                  )
                )}
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions disableSpacing={true}>
        <Button
          variant={"outlined"}
          color={"secondary"}
          className={classes.buttonAction}
          onClick={clearSelectVariant}
        >
          <FormattedMessage defaultMessage={"ยกเลิก"} />
        </Button>
        <Button
          variant={"contained"}
          color={"secondary"}
          className={classes.buttonAction}
          disabled={!Boolean(shipping)}
          onClick={handleSubmit}
        >
          <FormattedMessage defaultMessage={"ตกลง"} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalShipping;
